import { PostFilterBody } from '@api';

export const hasEmptyEntityTagValues = (filters: PostFilterBody): boolean => {
  if (!filters?.entity_tag?.values) {
    return false;
  }

  const allTags = filters.entity_tag.values.flatMap(value =>
    Array.isArray(value.tags) ? value.tags : []
  );

  return allTags.length === 0;
};
